import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Row} from 'react-bootstrap';
import Toast from "../../UI/Toast/Toast";
import { useLocation } from "react-router-dom";
import userService from "../../app/services/user.service";
import { linkReplaceFn } from "../../utils/custom_funtions";
import SecBTN from "../../UI/SecBTN";
import Loader from "../../UI/loader/loader";
import { Link } from "react-router-dom";


export const StudentDetails = () => {
    const [attemptedQuestions, setAttemptedQuestions] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);


    const location = useLocation();
    const { homework_id, user_id } = location.state || {};
    const optionselect=['a.','b.','c.','d.']

  

    useEffect(() => {
        getAttemptedQUestions();

    }, [])


    const getAttemptedQUestions = () => {
        userService.attemptedQuestion(homework_id, user_id)
            .then(res => {
                setAttemptedQuestions(res.data.data);
                console.log(res.data.data);

            })
            .catch(err => {
                console.log("failed to fetch data ", err);
            })
    };



    const handleNext = () => {
        if (currentQuestionIndex < attemptedQuestions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);

        }
    };

    // Handle Previous button to show the previous question
    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);

        }
    };

    // Get the current question based on the index
    const currentQuestion = attemptedQuestions[currentQuestionIndex];


    return (
        <div>
            <Toast />
            <div className="d-flex page-head justify-content-between m-10 align-items-center">
                <div>
                    <h4> Homework Details</h4>
                    <Breadcrumb>
                       <Link to='/HomeworkDetails'><Breadcrumb.Item active>Homework Details</Breadcrumb.Item></Link>
                        <Breadcrumb.Item active>{"  > Attempted Student Details"}</Breadcrumb.Item>
                        {/* <Breadcrumb.Item active>Completed</Breadcrumb.Item>
            <Breadcrumb.Item active>Questions</Breadcrumb.Item> */}
                    </Breadcrumb>
                </div>
            </div>
        {attemptedQuestions.length>0 ?" ":<Loader />}

        { currentQuestion &&
            <div className="preview-card1 preview-card">
                <div>
                    <p><b>{attemptedQuestions[0]?.name}</b></p>
                    <span className="preview-text"> Submittted On: {attemptedQuestions[0]?.submit_on}</span>

                </div>
            </div>
        }

            {currentQuestion && (
                <>

                    <div className="Question-container">
                        <div className="student_attempt_container c1">
                            <div className="student_count">
                                <h4>{currentQuestion.total_attempt}</h4>
                                <p>Students Attempted</p>
                            </div>
                            <div className="student_count">
                                <h4>{currentQuestion.total_correct}</h4>
                                <p>Correctly Answered</p>
                            </div>
                            <div className="student_count">
                                <h4>{currentQuestion.total_incorrect}</h4>
                                <p>Incorrectly Answered</p>
                            </div>
                        </div>

                        <div className="preview-card preview-card-vq">
                            <div>
                                <p className="q-number">Question: {currentQuestionIndex + 1}</p>
                                <span className="q-text" dangerouslySetInnerHTML={{
                                    __html: linkReplaceFn(currentQuestion.q_text)
                                }} />

                            </div>
                        </div>

                        <Row>
                            {currentQuestion.option.map((op, index) => (
                                <Col lg={6} sm={12} key={index}>
                                    <div className={`option-card ${op.is_correct == 1 ? 'right_answer' : ''}
                                     ${op.is_correct === 0 && op.is_user_correct_ans === 1 ? 'wrong_answer' : ''}`}>
                                        
                                        <span style={{ marginRight: '10px' }} >{optionselect[index]}</span>
                                        <span className="q-text" dangerouslySetInnerHTML={{
                                            __html: linkReplaceFn(op.option)
                                        }} >
                                           
                                        </span>



                                    </div>
                                </Col>
                            ))}
                        </Row>

                        <div className="Solution">
                            <div className="preview-card1 preview-card">
                                <div>
                                    <p><b>Solution</b></p>
                                    <span className="q-text" dangerouslySetInnerHTML={{
                                        __html: linkReplaceFn(currentQuestion.sol_text)
                                    }} />

                                </div>
                            </div>

                        </div>
                    </div>
                </>
            )}

          {
            currentQuestion &&
            <div className='Question-btn'>
                <SecBTN
                    className={`sec-btn`}
                    onClick={handlePrevious}
                    disabled={currentQuestionIndex === 0} 
                >
                    Previous
                </SecBTN>

                <SecBTN
                    className={`save-btn1`}
                    onClick={handleNext}
                    disabled={currentQuestionIndex === attemptedQuestions.length - 1} 
                >
                    Next
                </SecBTN>
            </div>

          }



        </div>
    )

    function newFunction() {
        console.log("sundarkand");
    }
}